<template>
  <footer class="l-footer">
    <span class="l-footer__sources">
      <router-link :to="sources.path" :title="sources.title" class="t-link">
        {{ sources.title }}
      </router-link>
    </span>
    <small class="l-footer__content">&copy; {{ year }}, {{ $t("title") }}</small>
    <a href="https://mambomambo.ca" title="MamboMambo, studio de design graphique et web" class="l-footer__content"
      >MamboMambo</a
    >
  </footer>
</template>

<script>
import { routes } from "src/router";

export default {
  name: "Footer",
  computed: {
    year: () => new Date().getFullYear(),
    sources() {
      const name = "sources";
      return {
        path: routes.find(route => route.name === name).path,
        title: this.$store.getters["global/getSingleTitle"](name)
      };
    }
  }
};
</script>

<style lang="scss">
.l-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: transform 0.3s ease-out;
  bottom: 0px;
  &:after {
    content: " ";
    height: 40px;
    width: 100%;
    @media #{$breakpoint-horizontal} {
      display: none;
    }
  }

  &.is-visible {
    transition: transform 0.2s $out-quad;
  }

  @media #{md("xs", "max")} {
    flex-wrap: wrap;
    font-size: 0.8em;
    padding-top: 0.3em;
    padding-bottom: 0.3em;

    .l-footer__sources {
      width: 100%;
    }
  }

  @media #{$breakpoint-vertical} {
    z-index: 100;
    padding-right: 0.5em;
    padding-left: 0.5em;
    background-color: $color-lighter;
    transform: translate(0, 100%);
    transform: translate(0);
    &.is-visible {
      transform: translate(0);
    }
  }

  @media #{$breakpoint-horizontal} {
    z-index: 1;
    position: fixed;
    top: calc(#{vh(50)} - #{$header-bottom-height}/ 2);
    right: calc(#{vh(-50)} + #{$header-bottom-height}/ 2);

    width: vh(100);
    height: $header-bottom-height;
    padding-right: 1.5em;
    padding-left: 1.5em;

    transform: rotate(-90deg) translate(0, 100%);

    &.is-visible {
      transform: rotate(-90deg) translate(0);
    }
  }
}

.l-footer__content {
  font-size: 1em;
}
</style>

<i18n>
{
    "fr": {
        "title" : "Mois de l'économie sociale"
    },
    "en": {
        "title" : "Social Economy Month"
    }
}
</i18n>
